// fotos.jsx


import IMGPrestador from '../../Assets/agendex/Prestador/icons';
import './fotos.css';

function Fotos(){
    return <section id="fotos">
        <div className="text-center my-5">
        <h3>Seus clientes usam um app único — o Agendex Cliente</h3>
        <p className="text-muted">Eles encontram todos os profissionais que já frequentam em um só lugar. Prático, rápido e gratuito para eles.</p>
        </div>
    </section>
}

export default Fotos;